module.exports = __webpack_public_path__ + "static/fiamma-campania-b8c7b86a66c68d91c4d0672d2b022bac.webp";